import React from "react";
import { Card, CardContent, Typography, CardHeader } from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import { NumericFormat } from "react-number-format";
import TableContainer from "@mui/material/TableContainer";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import RenderDate from "../../../Common/Date/RenderDate";

import RSAvatar from "../RSAvatar";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: 12,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const exceptions = [
    {
        type: "-",
        days: 1,
        date: "2021-10-18T11:03:47.166Z",
        status: "approved",
    },
    {
        type: "-",
        days: 1,
        date: "2021-09-12T11:03:47.166Z",
        status: "approved",
    },
    {
        type: "-",
        days: 1,
        date: "2021-06-23T11:03:47.166Z",
        status: "approved",
    },
    {
        type: "-",
        days: 1,
        date: "2021-02-11T11:03:47.166Z",
        status: "approved",
    },
];

function ExceptionsCard() {
    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={<RSAvatar type="exception" />}
                title={
                    <Typography component="h3" className="card-header-title">
                        Exceptions
                    </Typography>
                }
                subheader={
                    <Typography component="h4" className="card-header-subtitle">
                        <RenderDate date={""} />
                    </Typography>
                }
            />
            <CardContent>
                <TableContainer>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Date</StyledTableCell>
                                <StyledTableCell>Type&nbsp;</StyledTableCell>
                                <StyledTableCell align="right">
                                    Days&nbsp;
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                    Status&nbsp;
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {exceptions.map((row, index) => (
                                <StyledTableRow key={index}>
                                    <StyledTableCell component="th" scope="row">
                                        <RenderDate date={row.date} />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {row.type}
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        <NumericFormat
                                            value={row.days}
                                            decimalSeparator="."
                                            displayType="text"
                                            decimalScale={3}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        {row.status}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                            <StyledTableRow key="totals">
                                <StyledTableCell
                                    component="th"
                                    scope="row"
                                    sx={{ backgroundColor: "#FFFFFF" }}
                                ></StyledTableCell>
                                <StyledTableCell
                                    sx={{ backgroundColor: "#FFFFFF" }}
                                    colSpan={2}
                                >
                                    <Typography variant="subtitle2"></Typography>
                                </StyledTableCell>
                                <StyledTableCell
                                    align="right"
                                    sx={{ backgroundColor: "#FFFFFF" }}
                                ></StyledTableCell>
                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
}

export default ExceptionsCard;
